import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  props: {
    MuiButton: {
      disableElevation: true,
    },
  },
  typography: {
    fontFamily: 'sans-serif, Arial, Helvetica',
  },
  overrides: {
    MUIDataTableSearch: {
      searchText: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    MUIDataTableHeadCell: {
      sortAction: {
        alignItems: 'center',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 2,
      },
      label: {
        textTransform: 'none',
      },
    },
  },
  palette: {
    darkOrange: '#7D1416',
    darkGreen: '#5AD87C',
    dark: '#2C2C2C',
    primary: {
      main: '#AD1201',
     // dark: '#BF1201', // hover
      contrastText: '#fff',
    },
    secondary: {
      main: '#4DCC70',
      dark: '#43B763',
      contrastText: '#182825',
    },
    typography: {
      darkGreen: '#115222',
    },
    text: {
      secondary: '#115222',
    },
    chips: {
      primary: {
        background: '#F4DDD9',
        color: '#7D1416',
      },
      secondary: {
        background: '#DAEEDF',
        color: '#115222', 
      },
    },
  },
});

export default theme; 
